import { render, staticRenderFns } from "./EditTemplateMailComponent.vue?vue&type=template&id=fbda88da&"
import script from "./EditTemplateMailComponent.vue?vue&type=script&lang=js&"
export * from "./EditTemplateMailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports